import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import { SignalsLandingDraft, signalsLandingQuestions } from "@/components/site/SignalsLandingDraft";

const URL = "https://xauproacademy.com/signals";
const TITLE = "Gold Trade Alerts: Audited XAUUSD Record | XAU Pro Academy";
const DESCRIPTION =
  "How to choose the best gold signal provider: five due diligence checks, retail channels vs a structured desk, and an audited record of 241 XAUUSD trades with every loss published.";

export const Route = createFileRoute("/signals")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      {
        name: "keywords",
        content:
          "XAUUSD signals, gold signals, gold trading signals, XAUUSD trading signals, live gold signals, free gold signals, best gold signals, reliable forex signals, verified trading signals, gold signals telegram alternative, XAUUSD buy sell signals, smart money concepts gold, SMC signals, prop firm gold signals",
      },
      { property: "og:title", content: "XAUUSD Signals You Can Verify Before You Trust" },
      {
        property: "og:description",
        content:
          "Selective gold signals with defined risk and a published, audited track record including every loss. Free account, no card required.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "XAUUSD Signals You Can Verify Before You Trust" },
      {
        name: "twitter:description",
        content: "Selective gold signals with defined risk and an audited record. Free account, no card.",
      },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Service",
              "@id": `${URL}#service`,
              name: "XAUUSD Signals",
              serviceType: "Gold trading signals and market analysis",
              description: DESCRIPTION,
              url: URL,
              areaServed: "Worldwide",
              provider: {
                "@type": "Organization",
                name: "XAU Pro Academy",
                url: "https://xauproacademy.com",
              },
              offers: {
                "@type": "Offer",
                name: "Free account",
                price: "0",
                priceCurrency: "USD",
                url: URL,
              },
            },
            {
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "Home", item: "https://xauproacademy.com/" },
                { "@type": "ListItem", position: 2, name: "XAUUSD Signals", item: URL },
              ],
            },
            {
              "@type": "FAQPage",
              mainEntity: signalsLandingQuestions.map((q) => ({
                "@type": "Question",
                name: q.question,
                acceptedAnswer: { "@type": "Answer", text: q.answer },
              })),
            },
          ],
        }),
      },
    ],
  }),
  component: SignalsPage,
});

function SignalsPage() {
  return (
    <Layout>
      <SignalsLandingDraft variant="page" />
    </Layout>
  );
}
